import Company from "../model/Company";
import { addPresentation } from "./presentation";

export default addPresentation(Company, {
  canAdd: true,
  canEdit: true,
  canRemove: false,
  columns: ["Code", "Name", { title: "Country", width: "30%", align: "left", content: { name: "country.name" } }],
});
